import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
const _excluded = ["subGroup", "multi"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _indexOfInstanceProperty from "@babel/runtime-corejs3/core-js/instance/index-of";
/* eslint-disable @typescript-eslint/no-unused-vars */
//This is an automated application generator developed by Devon Miller-Junk for use by Expert Pro.
//This application generator reads all the information stored in the schemas repository in the default application
//json. When importing this file into new place, make sure that the imports listed below have the correct file path.
//Also remember to install faker in node_modules.
//If you wish to alter the results even more, simply add a mapping function to the mappingFunctions array, and the
//its functionality will automatically be included. To create an application simply call buildApp().
//For examples of how to run the app generators, see the functions at the bottom
//Used to construct the application
//Used to get different application statuses

export default class ApplicationGenerator {
  constructor(schema) {
    //Generally used functions:
    _defineProperty(this, "selectAppType", app => {
      //Selects type of application (refinance/purchase etc..)
      let num = -1;
      let options = [];
      for (let key in app) {
        num++;
        if (app[key] && key != "metadata") {
          options.push(key);
        }
      }
      return options[Math.floor(Math.random() * num)];
    });
    _defineProperty(this, "isEmpty", obj => {
      //Return true if obj === {}
      for (let key in obj) {
        if (obj[key]) return false;
      }
      return true;
    });
    _defineProperty(this, "isArray", value => {
      return value && typeof value === "object" && value.constructor === Array;
    });
    _defineProperty(this, "isObject", value => {
      return value && typeof value === "object" && value.constructor !== Array;
    });
    _defineProperty(this, "indexOf", (groups, group) => {
      //Returns index of the first object in the array that is equal to the group.
      if (groups == null) {
        return -1;
      }
      for (let i = 0; i < groups.length; i++) {
        if (groups[i] === group) {
          return i;
        }
      }
      return -1;
    });
    _defineProperty(this, "emptyArray", array => {
      let result = true;
      array.forEach(e => {
        if (!this.isEmpty(e)) {
          result = false;
        }
      });
      return result;
    });
    _defineProperty(this, "indexWith", (key, application) => {
      for (let i = 0; i < application.length; i++) {
        if (application[i].key === key) {
          return i;
        }
      }
      return -1;
    });
    _defineProperty(this, "removeFromApp", (application, section, column) => {
      if (this.defaultSchema.metadata["group-rules"][section].multi) {
        application[section].forEach(appSection => {
          if (appSection[column]) {
            delete appSection[column];
          }
        });
      } else {
        delete application[section][column];
      }
      return application;
    });
    _defineProperty(this, "populateColumns", (columns, metadata, flow, excluded = []) => {
      if (typeof columns === "string") {
        var _context;
        const {
          columns: populated,
          "group-title": groupTitle,
          "empty-by-default": defaultEmpty = false,
          multi = false
        } = metadata["group-rules"][columns];
        return _mapInstanceProperty(_context = _filterInstanceProperty(populated).call(populated, ({
          key
        }) => !_includesInstanceProperty(excluded).call(excluded, key))).call(_context, column => _objectSpread(_objectSpread({}, column), {}, {
          subGroup: columns,
          groupTitle,
          defaultEmpty,
          visible: column.visible[flow],
          validation: column.validation[flow],
          multi
        }));
      }
      return columns;
    });
    //Functions to fill the structure behind the data
    _defineProperty(this, "buildSection", element => {
      const type = element.type;
      let output;
      switch (type) {
        case "text":
          {
            return "";
          }
        case "email":
          {
            return "";
          }
        case "datepicker":
          {
            return "";
          }
        case "SIN":
          {
            return {
              1: "",
              2: "",
              3: ""
            };
          }
        case "radio":
          {
            return null;
          }
        case "select":
          {
            return "";
          }
        case "slide-input":
          {
            return null;
          }
        case "address":
          {
            return {
              city: "",
              line1: "",
              line2: "",
              "postal-code": "",
              province: "",
              "street-direction": "",
              "street-name": "",
              "street-number": "",
              "unit-number": "",
              "street-type": "",
              "time-at": ""
            };
          }
        case "grid":
          {
            return "";
          }
        default:
          {
            //eslint-disable-next-line no-console
            console.log("Error: Received " + type + " as input type");
            output = "Error: Received " + type + " as input type";
            break;
          }
      }
      return output || "ERROR nothing generated in build section";
    });
    _defineProperty(this, "buildPart", (element, flow) => {
      let part = {};
      element.sections.forEach(section => {
        const columns = this.populateColumns(section.columns, this.defaultSchema.metadata, flow);
        columns.forEach(_ref => {
          let {
              subGroup,
              multi
            } = _ref,
            column = _objectWithoutProperties(_ref, _excluded);
          const {
            multi: isMultiGroup,
            min = 1
          } = this.defaultSchema.metadata["group-rules"][section.group];
          if (isMultiGroup) {
            if (!part[section.group]) {
              part[section.group] = [];
              for (let i = 0; i < min; i++) {
                let type = {};
                if (subGroup) {
                  if (multi) {
                    type[subGroup] = type[subGroup] || [];
                    !type[subGroup].length ? type[subGroup].push({
                      [column.key]: this.buildSection(column)
                    }) : type[subGroup][0] = _objectSpread(_objectSpread({}, type[subGroup][0]), {}, {
                      [column.key]: this.buildSection(column)
                    });
                  } else {
                    type[subGroup] = type[subGroup] || {};
                    type[subGroup][column.key] = this.buildSection(column);
                  }
                } else {
                  type[column.key] = this.buildSection(column);
                }
                part[section.group].push(type);
              }
            } else {
              part[section.group].forEach(type => {
                if (subGroup) {
                  if (multi) {
                    type[subGroup] = type[subGroup] || [];
                    !type[subGroup].length ? type[subGroup].push({
                      [column.key]: this.buildSection(column)
                    }) : type[subGroup][0] = _objectSpread(_objectSpread({}, type[subGroup][0]), {}, {
                      [column.key]: this.buildSection(column)
                    });
                  } else {
                    type[subGroup] = type[subGroup] || {};
                    type[subGroup][column.key] = this.buildSection(column);
                  }
                } else {
                  type[column.key] = this.buildSection(column);
                }
              });
            }
          } else {
            if (!part[section.group]) {
              part[section.group] = {};
              if (subGroup && !part[section.group][subGroup]) {
                if (multi) {
                  part[section.group][column.subGroup] = [];
                } else {
                  part[section.group][column.subGroup] = {};
                }
              }
            }
            if (subGroup) {
              if (multi) {
                part[section.group][subGroup][0] = _objectSpread(_objectSpread({}, part[section.group][subGroup][0]), {}, {
                  [column.key]: this.buildSection(column)
                });
              } else {
                part[section.group][subGroup][column.key] = this.buildSection(column);
              }
            } else {
              if (multi) {
                part[section.group][column.key] = [_objectSpread({}, this.buildSection(column))];
              } else {
                part[section.group][column.key] = this.buildSection(column);
              }
            }
          }
        });
      });
      return part;
    });
    /**
     * Call the functions below when using this program.
     * All of the functions below generate apps and are used to alter them.
     */
    //Main function to build a random app
    //  ex: buildApp() to return a randomly generated app with no checking of any of the values.
    _defineProperty(this, "buildApp", flow => {
      let application = {};
      this.defaultSchema[flow].forEach(element => {
        if (element.multi) {
          const numCoapps = 1;
          application[element.key] = [];
          for (let i = 0; i < numCoapps; i++) {
            application[element.key].push(this.buildPart(element, flow));
          }
        } else {
          application[element.key] = this.buildPart(element, flow);
        }
      });
      return {
        application
      };
    });
    //  This function omits part of the application if it is not required.
    //  Pass in true if you only want the required information from an app, pass
    //  in false if you want all required and some of the not required information
    //  ex: buildRequiredApp(true, app) returns the minimal information in app;
    _defineProperty(this, "onlyRequiredApp", (minimal = true, application) => {
      this.defaultSchema[application.application.flow].forEach(tab => {
        tab.sections.forEach(section => {
          section.columns.forEach(column => {
            var _context2;
            if (_indexOfInstanceProperty(_context2 = this).call(_context2, column.validation, "required") == -1) {
              if (minimal) {
                if (tab.multi) {
                  //eslint-disable-next-line no-unused-vars
                  application.application[tab.key].forEach(part => {
                    //eslint-disable-next-line no-unused-vars
                    part = this.removeFromApp(part, section.group, column.key);
                  });
                } else {
                  application.application[tab.key] = this.removeFromApp(application.application[tab.key], section.group, column.key);
                }
              }
            }
          });
        });
      });
      return application;
    });
    //  This function is used to set specific data in an application
    //  ex: setDataInApp(app, { line1: "insert line 1" }) sets line1 to 'inset line 1' in the application app.
    _defineProperty(this, "setDataInApp", (section, data) => {
      if (this.isArray(section)) {
        //eslint-disable-next-line no-unused-vars
        section.forEach(part => {
          //eslint-disable-next-line no-unused-vars
          part = this.setDataInApp(part, data);
        });
      } else if (this.isObject(section)) {
        for (let key in section) {
          if (data[key] == null) {
            if (this.isArray(section[key])) {
              //eslint-disable-next-line no-unused-vars
              section[key].forEach(part => {
                //eslint-disable-next-line no-unused-vars
                part = this.setDataInApp(part, data);
              });
            } else if (this.isObject(section[key])) {
              for (let part in section[key]) {
                if (data[part] == null) {
                  section[key][part] = this.setDataInApp(section[key][part], data);
                } else {
                  section[key][part] = data[part];
                }
              }
            }
          } else {
            section[key] = data[key];
          }
        }
      }
      return section;
    });
    this.defaultSchema = schema;
  }
}